"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_native_1 = require("react-native");

var FontAwesome5_1 = __importDefault(require("react-native-vector-icons/FontAwesome5"));

var button_1 = require("../../../../components/pricing/buttons/button/button");

var autocomplete_field_1 = require("../../../../components/pricing/inputs/autocomplete-field/autocomplete-field");

var static_text_1 = require("../../../../components/pricing/text/static-text/static-text");

var drug_search_field_content_1 = require("../../../../theming/pricing-system/drug-search-field.content");

var theme_1 = require("../../../../theming/theme");

var theme_pricing_system_1 = require("../../../../theming/theme.pricing-system");

var strength_formatter_1 = require("../../../../utils/formatters/strength-formatter");

var format_pattern_helper_1 = require("./format-pattern-helper");

var itemViewStyle = {
  flexDirection: 'row',
  flexWrap: 'wrap',
  justifyContent: 'space-between',
  width: '100%'
};
var itemLeftTextStyle = {
  display: 'flex',
  flexDirection: 'column'
};
var itemRightTextStyle = {
  alignItems: 'flex-end',
  display: 'flex',
  flexDirection: 'column',
  marginLeft: '.2em'
};
var secondaryTextStyle = {
  color: theme_1.GreyScale.dark,
  fontSize: '.9em'
};
var labelContainerTextStyle = {
  alignItems: 'flex-end',
  display: 'flex',
  flexDirection: 'row'
};
var helpButtonViewStyle = {
  marginLeft: '-0.2em'
};

var DrugSearchField = function (_super) {
  __extends(DrugSearchField, _super);

  function DrugSearchField() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.autocompleteFieldRef = react_1.default.createRef();

    _this.clear = function () {
      var autocompleteRef = _this.autocompleteFieldRef.current;

      if (autocompleteRef) {
        autocompleteRef.clear();
      }
    };

    _this.validate = function () {
      var autocompleteRef = _this.autocompleteFieldRef.current;

      if (autocompleteRef) {
        autocompleteRef.validate();
      }
    };

    _this.focus = function () {
      var autocompleteRef = _this.autocompleteFieldRef.current;

      if (autocompleteRef) {
        autocompleteRef.focus();
      }
    };

    _this.renderItem = function (searchResultPatterns) {
      var namePattern = searchResultPatterns.namePattern || searchResultPatterns.genericNamePattern;
      var genericNamePattern = searchResultPatterns.genericNamePattern;

      if (_this.areNameAndGenericNameEqual(namePattern, genericNamePattern)) {
        genericNamePattern = '';
      }

      if (genericNamePattern) {
        genericNamePattern = "(" + genericNamePattern + ")";
      }

      var strengthAndFormContent = _this.buildStrengthAndFormContent(searchResultPatterns);

      return react_1.default.createElement(react_native_1.View, {
        style: itemViewStyle
      }, react_1.default.createElement(react_native_1.Text, {
        style: itemLeftTextStyle
      }, _this.renderWithHighlights(namePattern), _this.renderWithHighlights(genericNamePattern, secondaryTextStyle), _this.renderWithHighlights(searchResultPatterns.drugTypePattern, secondaryTextStyle)), react_1.default.createElement(react_native_1.Text, {
        style: itemRightTextStyle
      }, _this.renderWithHighlights(searchResultPatterns.ndcPattern), _this.renderWithHighlights(strengthAndFormContent, secondaryTextStyle), _this.renderWithHighlights(_this.buildPackageContent(searchResultPatterns), secondaryTextStyle)));
    };

    _this.findItems = function (filter) {
      if (_this.props.drugSearch) {
        var regex = /\)|\(|\||-|,/g;
        var sanitizedFilter = filter.replace(regex, ' ').replace(/\s+/g, ' ').trim();

        _this.props.drugSearch(sanitizedFilter);
      }
    };

    _this.onSelect = function (drugPatterns) {
      if (_this.props.onSelect) {
        _this.props.onSelect(drugPatterns ? drugPatterns.ndc : undefined);
      }
    };

    _this.filterExtractor = function (searchResultPatterns) {
      return format_pattern_helper_1.FormatPatternHelper.stripTags(_this.buildCombinedName(searchResultPatterns.namePattern, searchResultPatterns.genericNamePattern));
    };

    return _this;
  }

  DrugSearchField.prototype.render = function () {
    return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(autocomplete_field_1.AutocompleteField, {
      ref: this.autocompleteFieldRef,
      autoFocus: this.props.autoFocus,
      viewStyle: this.props.viewStyle,
      label: this.renderLabel(),
      data: this.resultData,
      debounceTimeout: this.props.drugSearchDebounceTimeout,
      minChars: this.props.drugSearchMinChars,
      noItemsMessage: drug_search_field_content_1.DrugSearchFieldContent.noMatchesMessage,
      invalidInputMessage: drug_search_field_content_1.DrugSearchFieldContent.invalidInputMessage,
      initialNumToRender: this.props.initialNumToRender,
      isBusy: this.props.isSearchInProgress,
      filterExtractor: this.filterExtractor,
      findItems: this.findItems,
      placeholder: drug_search_field_content_1.DrugSearchFieldContent.placeholder,
      onSelect: this.onSelect,
      renderItem: this.renderItem,
      isDisabled: this.props.isDisabled
    }));
  };

  DrugSearchField.prototype.renderLabel = function () {
    return react_1.default.createElement(react_native_1.Text, {
      style: labelContainerTextStyle
    }, react_1.default.createElement(static_text_1.StaticText, {
      text: drug_search_field_content_1.DrugSearchFieldContent.label
    }), this.renderHelpButton());
  };

  DrugSearchField.prototype.renderHelpButton = function () {
    var helpButtonLabel = react_1.default.createElement(FontAwesome5_1.default, {
      name: "question",
      size: 14
    });

    if (!this.props.onHelpDialogShow) {
      return null;
    }

    return react_1.default.createElement(button_1.Button, {
      label: helpButtonLabel,
      onPress: this.props.onHelpDialogShow,
      type: "icon",
      iconText: drug_search_field_content_1.DrugSearchFieldContent.helpButtonIconText,
      viewStyle: helpButtonViewStyle
    });
  };

  DrugSearchField.prototype.areNameAndGenericNameEqual = function (namePattern, genericNamePattern) {
    var name = format_pattern_helper_1.FormatPatternHelper.stripTags(namePattern || '').toLocaleLowerCase();
    var genericName = format_pattern_helper_1.FormatPatternHelper.stripTags(genericNamePattern || '').toLocaleLowerCase();
    return name === genericName;
  };

  DrugSearchField.prototype.renderWithHighlights = function (pattern, textStyle) {
    if (pattern === void 0) {
      pattern = '';
    }

    var contentItems = format_pattern_helper_1.FormatPatternHelper.parse(pattern);
    return react_1.default.createElement(react_native_1.Text, {
      style: textStyle
    }, contentItems.map(function (item, index) {
      var itemStyle = item.isHighlighted ? theme_pricing_system_1.pricingStyles.autocompleteFilterHighlightTextStyle : undefined;
      return react_1.default.createElement(react_native_1.Text, {
        key: index,
        style: itemStyle
      }, item.text);
    }));
  };

  DrugSearchField.prototype.buildStrengthAndFormContent = function (searchResultPatterns) {
    var strength = {
      unit: searchResultPatterns.strengthUnitPattern,
      value: searchResultPatterns.strengthPattern
    };
    var formattedStrength = strength_formatter_1.StrengthFormatter.format(strength);
    var formPattern = searchResultPatterns.formPattern;
    return formattedStrength ? formattedStrength + " " + formPattern : formPattern;
  };

  DrugSearchField.prototype.buildPackageContent = function (searchResultPatterns) {
    return this.formattedPackageContent(searchResultPatterns.packageTypePattern, searchResultPatterns.packageQuantityPattern);
  };

  DrugSearchField.prototype.formattedPackageContent = function (typePattern, quantityPattern) {
    var packageParts = [];

    if (quantityPattern) {
      packageParts.push(quantityPattern);
    }

    if (typePattern) {
      packageParts.push(typePattern);
    }

    return packageParts.join(' - ');
  };

  DrugSearchField.prototype.buildCombinedName = function (namePattern, genericNamePattern) {
    if (!namePattern) {
      return genericNamePattern;
    }

    if (!genericNamePattern) {
      return namePattern;
    }

    if (format_pattern_helper_1.FormatPatternHelper.stripTags(namePattern) === format_pattern_helper_1.FormatPatternHelper.stripTags(genericNamePattern)) {
      return namePattern;
    }

    return namePattern + " (" + genericNamePattern + ")";
  };

  Object.defineProperty(DrugSearchField.prototype, "resultData", {
    get: function get() {
      var result = this.props.drugSearchResult;

      if (!result) {
        return {
          items: [],
          totalItems: 0
        };
      }

      return {
        items: result.drugs,
        totalItems: result.totalMatches
      };
    },
    enumerable: true,
    configurable: true
  });
  return DrugSearchField;
}(react_1.default.Component);

exports.DrugSearchField = DrugSearchField;